import { atom, useAtom } from 'jotai';
var modeAtom = atom('not-ready');
var modeTrackingAtom = atom('package-details');
export function useAppMode() {
  return useAtom(modeAtom);
}
export function useTrackingMode() {
  return useAtom(modeTrackingAtom);
}